export default {
  Niv1_2_SEO: "Niv1&2_SEO",
  Niv1_2_Produits: "Zone_Univers_Produits",
  Niv1_2_MEA: "Zone_Univers_MEA",
  Mobile_Niv1_2_MEA: "Mobile_Zone_Univers_MEA",
  Niv1_2_Banniere: "Zone_Univers_Banniere",
  Mobile_Niv1_2_Bannière: "Mobile_Zone_Univers_Banniere",
  Niv1_2_MEA_Producteur: "Zone_Univers_MEA_Producteur",
  Mobile_Niv1_2_MEA_Producteur: "Mobile_Zone_Univers_MEA_Producteur",
  Niv1_2_MEA_Recette: "Zone_Univers_MEA_Recette",
  Mobile_Niv_1_2_MEA_Recette: "Mobile_Zone_Univers_MEA_Recette",
  Niv_1_2_Max_Description_length: 417,
  Mobile_Niv_1_2_Max_Description_length: 79,
  UNIVERS: "PageUnivers",
  MARQUE_LISTING: "PageMarqueUnivers",
  MARQUE_LANDING: "PageMarqueDescente",
  DP_Zone_Libre: "DP_Zone_Libre"
}
